// extracted by mini-css-extract-plugin
export default {"spinnerGeral":"styles_spinnerGeral__hwT5w"};